module.exports = __webpack_public_path__ + "img/givemycertificate.35a9c452.webp";